// extracted by mini-css-extract-plugin
export default {"card":"Promote_card__ev7aW"};